import React, { useMemo } from "react";
import CommonTable from "../../../../global/table";
import { formatDateTime } from "../../../../../utils/functions";
import NoRecordFound from "../../../../global/noRecordFound";
import { EyeOutlined } from "@ant-design/icons";

const EnhancedEmailLogList = ({
    emailLogs,
    sort,
    setSort,
    isLoading,
    viewDetail
}) => {
    const columns = [
        {
            title: "Client Email",
            dataIndex: "userEmail",
            key: "userEmail",
            sortType: "userEmail",
            render: (text) => (
                <span className="cursor-pointer text-primary">
                    {text}
                </span>
            ),
            isAvatar: true
        },
        {
            title: "Email To",
            dataIndex: "emailTo",
            key: "emailTo",
            sortType: "emailTo",
        },
        {
            title: "Sent At",
            dataIndex: "createdAt",
            key: "createdAt",
            sortType: "createdAt",
            render: (text) => formatDateTime(text),
        },
    ];

    const data = useMemo(() => {
        if (!emailLogs || !emailLogs.logs) return [];
        return emailLogs.logs.map((item, idx) => ({
            ...item,
            key: item._id || idx,
            id: item._id || idx,
        }));
    }, [emailLogs]);

    if (!isLoading && (!data || data.length === 0)) {
        return <NoRecordFound message="No email logs found." />;
    }

    return (
        <CommonTable
            columns={columns}
            data={data}
            sort={sort}
            setSort={setSort}
            onRowClick={(record) => viewDetail(record)}
        />
    );
};

export default EnhancedEmailLogList;
